import React, {useState} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {BookmarkIcon, UpvoteIcon} from './svg';
import {formatLargeNum} from '../util';

export function SaveButton({initialValue, onClick, className}) {
  const [saved, setSaved] = useState(initialValue);

  const onSave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setSaved(!saved);
    onClick(!saved);
  };

  return (
    <button
      type="button"
      className={cx('whitespace-nowrap flex items-center text-sm font-normal text-gray-500 hover:text-gray-600', className)}
      onClick={onSave}
    >
      <BookmarkIcon fill={saved ? 'currentColor' : 'none'} className="mr-1 h-4 w-4" />
      {saved ? 'Saved' : 'Save'}
    </button>
  );
}

export function UpvoteButton(props) {
  const {
    count,
    voted,
    onClick,
    large,
    numberOnly,
    className,
  } = props;

  let voteText;

  if (numberOnly) {
    voteText = formatLargeNum(count);
  } else if (count === 0) {
    voteText = 'Upvote';
  } else if (count === 1) {
    voteText = '1 vote';
  } else {
    voteText = `${formatLargeNum(count)} votes`;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cx(['UpvoteButton', className], {
        'UpvoteButton--voted': voted,
        'UpvoteButton--large': large,
      })}
    >
      <UpvoteIcon color={voted ? '#e9b600' : null} />
      {voteText}
    </button>
  );
}

UpvoteButton.propTypes = {
  count: PropTypes.number.isRequired,
  voted: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  large: PropTypes.bool,
  numberOnly: PropTypes.bool,
  className: PropTypes.string,
};

UpvoteButton.defaultProps = {
  large: false,
  numberOnly: false,
  className: null,
};
